import React, { useState, useEffect } from "react";
import * as styles from "./ToTopButton.module.scss"
import { useIntl } from "gatsby-plugin-intl";

interface ScrollToTopButtonProps {
	threshold?: number; // Порог появления кнопки (в пикселях)
}

const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({
	threshold = 800,
}) => {
	const [isVisible, setIsVisible] = useState(false);

	// следим за прокруткой
	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > threshold) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [threshold]);

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	if (!isVisible) return null;

	const intl = useIntl()

	return (
		<button
			onClick={scrollToTop}
			className={styles.button}

			aria-label="Back to top"
		>
			<span>{intl.formatMessage({ id: "footer.navigation.back-to-top" })}</span>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				fill="none"
				viewBox="0 0 24 24"
			>
				<path
					fill="#3f3f3f"
					d="m9.293 3.293 1.414 1.414L4.414 11H22v2H4.414l6.293 6.293-1.414 1.414L2 13.414v-2.828z"
				/>
			</svg>
		</button>
	);
};

export default ScrollToTopButton;
